export default "__VITE_ASSET__BHWtdNnE__"